import { motion } from "framer-motion";
import { Reveal, SectionHead } from "@/components/Shared";

const PHOTOS = [
  {
    id: "nielit",
    src: "/field/nielit.jpg",
    alt: "Bhumika Vyas felicitated at NIELIT Headquarters, New Delhi, March 2024",
    tag: "Felicitation · NIELIT HQ · March 2024",
    caption: "Seven years inside the national skilling mission, closed out at NIELIT Headquarters, New Delhi.",
  },
  {
    id: "taiwan",
    src: "/field/taiwan.jpg",
    alt: "Bhumika Vyas with a Taiwanese government delegate",
    tag: "Taiwan Engagement",
    caption: "Bilateral technology dialogue with a Taiwanese delegation.",
  },
  {
    id: "tanzania",
    src: "/field/tanzania.jpg",
    alt: "Bhumika Vyas with a Government of Tanzania ministerial delegation",
    tag: "Govt. of Tanzania",
    caption: "Advisory engagement with a ministerial delegation from Tanzania.",
  },
  {
    id: "skilling",
    src: "/field/skilling.jpg",
    alt: "Skilling the Nation drive with students holding up program kits",
    tag: "Skilling the Nation",
    caption: "Nationwide digital skilling drive, delivered on the ground with students.",
  },
  {
    id: "booth",
    src: "/field/booth.jpg",
    alt: "The Skilling the Nation pavilion team at the national exhibition",
    tag: "Skilling the Nation · Expo Floor",
    caption: "The pavilion team at the national skilling exhibition.",
  },
  {
    id: "expo",
    src: "/field/expo.jpg",
    alt: "NIELIT exhibition pavilion showcasing Ethical AI",
    tag: "NIELIT Expo Pavilion",
    caption: "Ethical AI and emerging-tech showcase on the exhibition floor.",
  },
  {
    id: "conclave",
    src: "/field/conclave.jpg",
    alt: "Startup Conclave 2025 stage during the MoU ceremony with SSIP and i-Hub Gujarat",
    tag: "Startup Conclave 2025 · Gandhinagar",
    caption: "MoU signing with i-Hub Gujarat at Startup Conclave 2025.",
  },
  {
    id: "stpi-mou",
    src: "/field/stpi-mou.jpg",
    alt: "MoU signing with AIC STPINEXT Initiatives at STPI Headquarters, New Delhi",
    tag: "STPI HQ · New Delhi · August 2025",
    caption: "MoU signing with AIC STPINEXT Initiatives at STPI Headquarters.",
  },
];

export default function InTheField() {
  return (
    <section
      id="in-the-field"
      data-testid="field-section"
      className="border-t border-[rgba(212,175,55,0.12)] bg-[#0A1222]/40 py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead
          overline="In the Field"
          title={<>On the ground, inside <em className="gold-text not-italic">the system.</em></>}
          testId="field-heading"
        />

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          {PHOTOS.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.08}>
              <figure data-testid={`field-photo-${p.id}`} className="group">
                <div className="clip-frame border border-[rgba(212,175,55,0.3)] p-1.5">
                  <div className="clip-frame overflow-hidden">
                    <motion.img
                      src={p.src}
                      alt={p.alt}
                      loading="lazy"
                      className="aspect-[4/3] w-full object-cover"
                      whileHover={{ scale: 1.04 }}
                      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    />
                  </div>
                </div>
                <figcaption className="mt-3.5">
                  <p className="font-mono-alt text-[9px] uppercase tracking-[0.26em] text-[#D4AF37]">{p.tag}</p>
                  <p className="mt-1.5 text-xs leading-relaxed text-[#94A3B8] sm:text-sm">{p.caption}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p
            data-testid="field-footnote"
            className="mt-14 border-t border-[rgba(212,175,55,0.15)] pt-6 text-center font-mono-alt text-[10px] uppercase tracking-[0.28em] text-[#64748B]"
          >
            NIELIT · Government of Tanzania · Taiwan · Government of India missions
          </p>
        </Reveal>
      </div>
    </section>
  );
}
